module.exports = __webpack_public_path__ + "static/media/GQ.a402d7e0.svg";